import { createApp } from 'vue';
import CultureSelector from './CultureSelector.vue';

export default function mountCultureSelector() {
	const cultureSelectorBlock = document.getElementById('culture-selector');

	if(!cultureSelectorBlock) {
		console.warn('[cultureSelector Container not found');
		return;
	}

	const app = createApp({
		name: 'culture-selector block',
	});

	app.component('culture-selector', CultureSelector);

	app.mount(cultureSelectorBlock);
}